"use client";

import { CapabilityPage } from "@/components/sections/page-composer";
import { sdkData } from "@/lib/data/developers-sdk";

export function SdkPage() {
  return <CapabilityPage data={sdkData} />;
}
